var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9574 5C14.5518 5 14.7673 5.06188 14.9846 5.17809C15.2018 5.29429 15.3724 5.46482 15.4886 5.6821C15.6048 5.89939 15.6667 6.11491 15.6667 6.70926V11.2907C15.6667 11.8851 15.6048 12.1006 15.4886 12.3179C15.3724 12.5352 15.2018 12.7057 14.9846 12.8219C14.7673 12.9381 14.5518 13 13.9574 13H10.9987L8.52027 15.4795C8.32504 15.6748 8.00846 15.6748 7.81317 15.4796C7.71937 15.3858 7.66667 15.2586 7.66667 15.126V13H6.70926C6.11491 13 5.89939 12.9381 5.6821 12.8219C5.46482 12.7057 5.29429 12.5352 5.17809 12.3179C5.06188 12.1006 5 11.8851 5 11.2907V6.70926C5 6.11491 5.06188 5.89939 5.17809 5.6821C5.29429 5.46482 5.46482 5.29429 5.6821 5.17809C5.89939 5.06188 6.11491 5 6.70926 5H13.9574Z",
    fill: "url(#paint0_linear_2949_132481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2949_132481",
    x1: 10.3333,
    y1: 5,
    x2: 10.3333,
    y2: 15.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressChat);
export default __webpack_public_path__ + "static/media/express_chat.8e6788e41e414fe5a709a17252d54c04.svg";
export { ForwardRef as ReactComponent };